if (!customElements.get('marks-accordion')) {
  class MarksAccordion extends HTMLElement {
    constructor() {
      super();
      this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
      this.toggles = Array.from(this.querySelectorAll('[data-accordion-toggle]'));
      this.panels = Array.from(this.querySelectorAll('[data-accordion-panel]'));
      this.mediaItems = Array.from(this.querySelectorAll('[data-accordion-media]'));
      this.initialIndex = parseInt(this.dataset.initialOpenIndex, 10) || 0;
    }

    connectedCallback() {
      if (!this.items.length) {
        return;
      }

      this.bindEvents();
      this.openItem(this.initialIndex);
    }

    bindEvents() {
      this.toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const item = toggle.closest('[data-accordion-item]');

          if (!item) {
            return;
          }

          const index = parseInt(item.dataset.itemIndex, 10) || 0;
          this.openItem(index);
        });
      });
    }

    openItem(indexToOpen) {
      this.items.forEach((item, index) => {
        const isActive = index === indexToOpen;
        const toggle = item.querySelector('[data-accordion-toggle]');
        const panel = item.querySelector('[data-accordion-panel]');

        item.classList.toggle('is-active', isActive);

        if (toggle) {
          toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }

        if (panel) {
          panel.hidden = !isActive;
        }
      });

      this.mediaItems.forEach((media, index) => {
        const mediaIndex = parseInt(media.dataset.itemIndex, 10) || 0;
        const isActive = mediaIndex === indexToOpen;
        media.classList.toggle('is-active', isActive);
        media.hidden = !isActive;
      });
    }
  }

  customElements.define('marks-accordion', MarksAccordion);
}
